import { Box, Button } from '@mui/material';
import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './auth-logo.svg';
import './index.css';

interface AuthLayoutProps {
    children: ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: theme => theme.palette.neutralBlack.main,
            }}
        >
            {/* Header */}
            <Box
                component="header"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: { xs: 2, md: 10 },
                    py: 2.5,
                    bgcolor: 'black',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    {/* Logo */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            cursor: 'pointer',
                        }}
                        onClick={() => navigate('/login')}
                    >
                        <img
                            src={Logo}
                            alt="Upercut logo"
                            style={{
                                height: '54.514px',
                                width: '145.171px',
                            }}
                        />
                    </Box>

                    {/* Connexion Button */}
                    <Button
                        variant="outlined"
                        onClick={() => navigate('/login')}
                        sx={{
                            border: '1px solid white',
                            borderRadius: '24px',
                            px: 3,
                            py: 1.5,
                            color: 'white',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '24px',
                            textTransform: 'none',
                            '&:hover': {
                                border: '1px solid white',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            },
                        }}
                    >
                        Connexion
                    </Button>
                </Box>
            </Box>

            {/* Main Content */}
            <Box
                component="main"
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: { xs: 2, md: 4 },
                }}
            >
                {children}
            </Box>
        </Box>
    );
};
